var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_169398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6074 4.50802L15.4692 4.23163H15.1602H4.03652C2.64461 4.23163 1.51074 5.35236 1.51074 6.74567V24.9705C1.51074 26.3606 2.64635 27.4845 4.02694 27.4845H29.3279C30.7179 27.4845 31.8441 26.3574 31.8441 24.9665V10.7956C31.8441 9.40259 30.7105 8.27761 29.3152 8.27761H17.4922L15.6074 4.50802Z",
    fill: "#3990E4",
    stroke: "#414955"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.627 11.7555L13.8115 8.33669H3.82875C2.82469 8.33669 2.01074 9.09709 2.01074 10.0385V25.4383C2.01074 26.3782 2.82746 27.1401 3.82015 27.1401H29.5347C30.534 27.1401 31.3441 26.3772 31.3441 25.4349V13.4607C31.3441 12.5189 30.5298 11.7555 29.5233 11.7555H15.627Z",
    fill: "#5AA5ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_169398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.677429 0.731628)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectory);
export default __webpack_public_path__ + "static/media/directory.c3e0467403ed581cbcc067f144808f69.svg";
export { ForwardRef as ReactComponent };